<table class="table">
  <thead class="globalSearchHead">
    <tr>
      @if(showCheckboxes){
      <th class="checkbox-width">
        <label class="custom-checkbox">
          <input type="checkbox" (change)="onHeaderCheckboxChange($event)">
          <span class="checkmark"></span>
        </label>
      </th>
      }
      @for (item of displayedColumns; track item){
      <th 
    [ngClass]="columnConfs[item.id]?.cssClass"
    (click)="sortTable(item.id)"
    [style.width]="item.width ? item.width : 'auto'">
  {{ item.name }}
  <span *ngIf="sortColumn === item.id">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
</th>

      <!-- @for (item of displayedColumns; track item) {
      <th [ngClass]="columnConfs[item.id]?.cssClass">
        {{ item.name }}
      </th>-->
      }
    </tr> 
  </thead>
  <tbody class="globalSearchBody">
    @if ((dataTable && dataTable.length == 0) && !isLoader) {
      <tr>
        <td [attr.colspan]="showCheckboxes ? displayedColumns.length + 1 : displayedColumns.length" class="text-center">
          <span class="no-record">No records found</span>
        </td>
      </tr>
    }@else {
      @for (row of dataTable; track row) {
        <tr [ngClass]="{'cursor-pointer': enableRowClick}"
        (click)="enableRowClick ? onRowClick(row) : null">
          @if(showCheckboxes){
          <td>
            <label class="custom-checkbox">
              <input type="checkbox"[checked]="isSelected(row)" (change)="onCheckboxChange($event,row)">
              <span class="checkmark"></span>
            </label>
          </td>
          }
          @for (column of displayedColumns; track column) {
          <td  [ngStyle]="type === 'sticky' && $index===0? {'position': 'sticky','left': '0'} : {}">
            @if(isLoader) {
              <dp-loader></dp-loader>
            } @else {
              <dynamic-component [type]="column.id" [rowData]="row" [data]="row[column.id]" [componentMap]="componentMap"
              (cellClick)="onCellClick($event)"></dynamic-component>
            }
          </td>
          }
        </tr>
        }
    }




  </tbody>
</table>
